import * as React from "react";

const IconTextLinkSignoutInactive: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 11"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#0A57A4" d="M3.75 9.25h-1.5a.75.75 0 01-.75-.75v-6a.75.75 0 01.75-.75h1.5a.75.75 0 000-1.5h-1.5A2.25 2.25 0 000 2.5v6a2.25 2.25 0 002.25 2.25h1.5a.75.75 0 000-1.5zm8.03-4.28l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H4.5a.75.75 0 100 1.5h4.94L7.72 7.97a.75.75 0 101.061 1.06l3-3a.75.75 0 00-.001-1.06z" opacity=".66"/></svg>;
};

export default React.memo(IconTextLinkSignoutInactive);
